import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import moment from 'moment';
import { Box, Typography } from '@mui/material';
const DateInfo = ({ date }) => {
    const momentDate = moment(date);
    return (_jsxs(Box, { display: 'flex', flexDirection: 'column', minWidth: 0, title: momentDate.toLocaleString(), children: [_jsx(Typography, { variant: 'body2', fontWeight: 500, noWrap: true, children: momentDate.format('D MMM yyyy') }), _jsx(Typography, { variant: 'caption', noWrap: true, children: momentDate.format('h:mm A') })] }));
};
export default memo(DateInfo);
